import { render, staticRenderFns } from "./dashboardUnidades.vue?vue&type=template&id=71dc1e38&scoped=true"
import script from "./dashboardUnidades.vue?vue&type=script&lang=js"
export * from "./dashboardUnidades.vue?vue&type=script&lang=js"
import style0 from "./dashboardUnidades.vue?vue&type=style&index=0&id=71dc1e38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dc1e38",
  null
  
)

export default component.exports